<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <h1>代理申請</h1>
        <p class="my-3">&nbsp;</p>
        <p class="formTitle">已申請數量</p>
        <p>
          <span class="red" name="TotalInvUsed"></span> /
          <span name="InvitationQuota"></span>
        </p>
        <p class="my-3">&nbsp;</p>
        <form id="form" @submit.prevent="submitClientPreReg">
          <!-- hidden -->
          <input type="hidden" name="RegNo" />
          <input type="hidden" name="Lang" value="tw" />
          <!-- hidden end -->
          <p class="formTitle">語言 <span class="red">*</span></p>
          <label
            ><input
              type="radio"
              name="eLang"
              value="tw"
              class="largeItem"
              v-model="E_Lang"
              checked
            />
            中文版</label
          >
          &nbsp;
          <label
            ><input
              type="radio"
              name="eLang"
              value="en"
              class="largeItem ml-2"
              v-model="E_Lang"
            />
            英文版</label
          >
          <p class="my-3">&nbsp;</p>
          <p class="formTitle">Email <span class="red">*</span></p>
          <input
            type="email"
            name="ClientEmail"
            class="textStyle maxText"
            maxlength="50"
            required
            placeholder="Email Address Here"
            v-model="ClientEmail"
          />
          <p class="my-3">&nbsp;</p>
          <p class="align_c">
            <input type="submit" value="確定送出" class="btnStyle" />
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      CSRF_Token: "",
      RegNo: "",
      E_Lang: "tw",
      ClientEmail: "",
      lang: "tw",
      MenuInvitation: [],
    };
  },

  methods: {
    InviteLink(Url) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`;
      }
    },

    closefancybox() {
      parent.$.fancybox.close();
    },

    submitClientPreReg() {
      const vm = this;

      const url = "/apiExhibitors/ClientPreReg/";

      const info = {
        RegNo: vm.RegNo,
        E_Lang: vm.E_Lang,
        ClientEmail: vm.ClientEmail,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      if (vm.lang == "tw") {
        if (!vm.ClientEmail) {
          alert("輸入欄位不完整，請重新檢查！");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert(`代理申請信已寄至您填寫的信箱 \n ${vm.ClientEmail}`);
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("您輸入的Email錯誤！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("您輸入的Email錯誤！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 254) {
              alert("您填入的Email已有參觀資格！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 255) {
              alert("超過代理登錄額度！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 256) {
              alert("已過代理申請時間！");
              vm.closefancybox();
              parent.window.location.reload();
            }
          });
        }
      } else {
        if (!vm.ClientEmail) {
          alert("There are incomplete fields, please check again.");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert(
                `Client registration has been sent to your email! \n ${vm.ClientEmail}`
              );
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("Invalid email, please check again.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 254) {
              alert("The email you entered already have admission.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 255) {
              alert("You have reached the limited amount quota!");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 256) {
              alert("Client registration is closed! ");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
              vm.closefancybox();
              parent.window.location.reload();
            }
          });
        }
      }
    },
  },

  created() {
    const vm = this;

    //取得語系

    let lang = "tw";

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;

    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.Type = currentUrl.split("d=")[1];

    //取得邀請選單
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data)

        vm.MenuInvitation = response.data.Data;
      });

    $.getJSON(
      "/apiExhibitors/Exhibition/" + vm.RegNo,
      { lang: lang },
      function (data) {
        $('[name="ExhEnd"]').text(data.Data.ExhEnd);

        // console.log(data.Data)

        var CloseDay = new Date(data.Data.ExhEnd);
        var currentdate = Date.parse(new Date()).valueOf();

        //設定畢展時間 Timestamp
        CloseDay.setDate(CloseDay.getDate());
        //6點前關閉
        var ExhTime = Date.parse(CloseDay) + 64800000;

        if (currentdate > ExhTime) {
          if (lang == "tw") {
            $(".btnStyle").addClass("btnExpire");
          } else {
            $(".btnStyle").addClass("ebtnExpire");
          }
        }

        if (lang == "tw") {
          if (data.Data.Caution == "") {
            $(".Caution").addClass("HideCaution");
          } else {
            $(".Caution").addClass("ShowCaution");
            $('[name="Caution"]').text(data.Data.Caution);
          }
        } else {
          if (data.Data.eCaution == "") {
            $(".Caution").addClass("HideCaution");
          } else {
            $(".Caution").addClass("ShowCaution");
            $('[name="Caution"]').text(data.Data.eCaution);
          }
        }

      }
    );

    $.getJSON("/apiExhibitors/PreRegTotal_Quota/" + vm.RegNo, function (data) {
      // console.log(data.Data)

      let InvitationQuota = data.Data.InvitationQuota;
      let TotalInvUsed = data.Data.TotalInvUsed;
      let TotalVisitor = data.Data.TotalVisitor;
      let TotalMember = data.Data.TotalMember;

      $('[name="InvitationQuota"]').text(InvitationQuota);
      $('[name="TotalInvUsed"]').text(TotalInvUsed);
      $('[name="TotalVisitor"]').text(TotalVisitor); // TotalVisitor 已報到人數
      $('[name="TotalMember"]').text(TotalMember); //TotalMember 已完成登入人數

      //判斷是否額滿
      if (data.Data.InvitationQuota == data.Data.TotalInvUsed) {
        if (lang == "tw") {
          $(".btnStyle").addClass("btnFull");
        } else {
          $(".btnStyle").addClass("ebtnFull");
        }
      }
    });
  },
};
</script>

<style lang="scss"></style>
